import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

interface UploadOnboardingDocumentResponse {
  ok: boolean;
  document: { code: string; status: string; fileUrl: string };
  completionPercent: number;
}

/**
 * Uploads a file for one of an employee's candidateDocuments checklist
 * entries (Aadhar, PAN, etc. — Employee360Page's Documents tab). Authorized
 * server-side for superadmin, admin, or HR-department users only (see
 * POST /api/hr/people/by-user/:userId/onboarding/documents/:code/upload).
 * Same OnboardingCandidate record the E-Joining portal writes to.
 */
export function useUploadOnboardingDocument(userId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ code, file }: { code: string; file: File }) => {
      const form = new FormData();
      form.append('file', file);
      const { data } = await api.post<UploadOnboardingDocumentResponse>(
        `/api/hr/people/by-user/${encodeURIComponent(userId!)}/onboarding/documents/${encodeURIComponent(code)}/upload`,
        form,
        { headers: { 'Content-Type': null } }, // let the browser set the multipart boundary
      );
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['hr', 'employee-360', userId] }),
  });
}
